export default __webpack_public_path__ + "static/media/zoo-de-lille-bicolore.367a0372.png";